import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { ProgressBar } from 'components/ProgressBar/ProgressBar'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import Styles from '../RefineMediaModal.module.scss'

interface ProcessingProps {
  sourceImageUrl: string
  progress: number
  isVideo: boolean
  onClose: () => void
  onBack: () => void
}

function getProcessingStatusText(progress: number, isVideo: boolean) {
  if (progress < 50) {
    return 'Analyzing source image'
  }
  return isVideo ? 'Generating video' : 'Generating image'
}

export function Processing({ sourceImageUrl, progress, isVideo, onClose, onBack }: ProcessingProps) {
  return (
    <>
      <Modal.Header title={`Revised ${isVideo ? 'video' : 'image'}`} onClose={onClose} />
      <Modal.Content>
        <div className={Styles.processingContent}>
          <div className={Styles.processingImageContainer}>
            <img src={sourceImageUrl} alt="Processing" className={Styles.processingImage} />
            <div className={Styles.processingOverlay}>
              <ProgressBar
                percentage={progress}
                color="var(--light-100)"
                backgroundColor="var(--dark-15)"
                size="xs"
                width="112px"
              />
              <Text color="var(--light-60)">
                {getProcessingStatusText(progress, isVideo)}
                <LoadingEllipses />
              </Text>
            </div>
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button variant="tertiary" size="lg" onPress={onBack}>
            Back
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" isDisabled>
            Insert into design
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
